"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getFuturesAvailableObservable = void 0;
const rxjs_1 = require("rxjs");
const operators_1 = require("rxjs/operators");
const trade_utils_lib_1 = require("trade_utils_lib");
const CalculateUtils_1 = require("../../Trade/FutureTrade/CalculateUtils");
const const_1 = require("./../../../component/const");
const trade_quotation_lib_1 = require("trade_quotation_lib");
const AssetsMarginInfoProvider_1 = require("../../../component/FuturesConfig/AssetsMarginInfoProvider");
const _1 = require(".");
// 传进来的是 quote，不带 PERP 后缀，这里给拼上
function getBase(coin) {
    let base = coin.toLocaleUpperCase();
    if (/\.PERP$/.test(coin)) {
        return base;
    }
    return `${base}.PERP`;
}
/**获取可用保证金,支持单币种保证金和联合保证金 */
function getFuturesAvailableObservable(coin, assets) {
    let customAssetsObservable;
    if (assets) {
        customAssetsObservable = (0, rxjs_1.of)(assets);
    }
    else {
        customAssetsObservable = (0, _1.getCustomAssetsObservable)();
    }
    return customAssetsObservable.pipe((0, rxjs_1.mergeMap)((assets) => {
        var _a, _b, _c;
        if (CalculateUtils_1.CalculateUtils.isMultiAssetMarginMode(assets.assets_margin_mode) && !CalculateUtils_1.CalculateUtils.isVirtualSymbol(coin)) {
            // 保证金实际值，有正负 权益-占用
            const quoteRisk = (_a = assets.quoteRisks) === null || _a === void 0 ? void 0 : _a[0];
            const avaMarginU = new trade_utils_lib_1.SafeDecimal(quoteRisk === null || quoteRisk === void 0 ? void 0 : quoteRisk.multi_mode_equity).sub(new trade_utils_lib_1.SafeDecimal(quoteRisk === null || quoteRisk === void 0 ? void 0 : quoteRisk.multi_init_margin));
            const availU = trade_utils_lib_1.SafeDecimal.max(avaMarginU, 0);
            // 如果币种为中介币，不用折算直接返回可用
            if (coin === const_1.MultiIntermediaryEquity) {
                return (0, rxjs_1.of)({
                    availableMargin: avaMarginU.toFixed(),
                    available: availU.toFixed(),
                    total_initial_margin: quoteRisk === null || quoteRisk === void 0 ? void 0 : quoteRisk.multi_init_margin,
                    unrealized_pnl: undefined,
                });
            }
            // 获取指数价格
            return (0, trade_quotation_lib_1.getGlobalQuotationSocketMgr)()
                .getFIndexWebSocket()
                .getFIndexObservableByPair("pionex.v2", getBase(coin), const_1.MultiIntermediaryEquity)
                .pipe((0, operators_1.zipWith)(AssetsMarginInfoProvider_1.assetMarginInfoData$), (0, operators_1.throttleTime)(1000), (0, operators_1.map)(([index, configs]) => {
                const config = configs === null || configs === void 0 ? void 0 : configs.coins.find((item) => item.coin === coin);
                // 获取指数价格
                const indexPrice = new trade_utils_lib_1.SafeDecimal(index.index_price);
                // 担保率
                const rate = new trade_utils_lib_1.SafeDecimal(config === null || config === void 0 ? void 0 : config.collateral_ratio);
                // 缓冲卖价
                const mortgagePrice = indexPrice.div(rate);
                // 实际可用保证金，可能为负值 usdt除以缓冲卖价
                const margin = avaMarginU.div(mortgagePrice);
                // 可用余额，最小为0
                const avai = trade_utils_lib_1.SafeDecimal.max(0, margin);
                return {
                    availableMargin: margin.toFixed(),
                    available: avai.toFixed(),
                    total_initial_margin: quoteRisk === null || quoteRisk === void 0 ? void 0 : quoteRisk.multi_init_margin,
                    unrealized_pnl: undefined,
                };
            }));
        }
        else {
            const b = assets === null || assets === void 0 ? void 0 : assets.balanceMap.get(coin);
            return (0, rxjs_1.of)({
                availableMargin: (_b = b === null || b === void 0 ? void 0 : b.availableMargin) !== null && _b !== void 0 ? _b : "",
                available: (_c = b === null || b === void 0 ? void 0 : b.available) !== null && _c !== void 0 ? _c : "",
                unrealized_pnl: b === null || b === void 0 ? void 0 : b.unrealized_pnl,
                total_initial_margin: b === null || b === void 0 ? void 0 : b.total_initial_margin,
            });
        }
    }));
}
exports.getFuturesAvailableObservable = getFuturesAvailableObservable;
